import { driverLicenseTypes } from '@cobliteam/common-types';
import { FormControl, FormField, FormItem, FormLabel, FormMessage, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@cobliteam/ui/form';
import DriverCNHInput from './DriverCNHInput';

const DriverLicenseInput = () => {
  const selectOptions = Object.entries(driverLicenseTypes).map((driverLicenseType) => ({
    value: driverLicenseType[0],
    label: driverLicenseType[1],
  }));

  return (
    <div className='flex gap-3'>
      <DriverCNHInput />
      <FormField name='licenseCategory'>
        {({ field }) => {
          return (
            <FormItem className='w-full space-y-1'>
              <FormLabel>Categoria</FormLabel>
              <FormControl>
                <Select value={field.value ?? ''} onValueChange={field.onChange}>
                  <SelectTrigger data-testid={'select-license-category'}>
                    <SelectValue placeholder='Selecionar categoria' />
                  </SelectTrigger>
                  <SelectContent portal={false}>
                    {selectOptions.map(({ value, label }) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      </FormField>
    </div>
  );
};

export default DriverLicenseInput;
